// 2026-10-29: scorecard me SIRF team naam + score allpanel scoreboard JSON se (baaki UI/data purana).
// Source: https://2xbat.co/sbscore/<gmid>/bootstrap  (2xbat.co nginx proxy → allpanel CloudFront, 2s cache, CORS *)
// Allpanel na mile / teams naam se match na hon → kuch nahi badalta (purana data jaisa tha).
import { useEffect, useState } from 'react';

const SB_BASE = 'https://2xbat.co/sbscore';
const POLL_MS = 3000;

/** allpanel bootstrap (`score` object) poll; null = data nahi */
export function useAllpanelBoot(gmid, enabled = true) {
  const [boot, setBoot] = useState(null);
  useEffect(() => {
    setBoot(null);
    if (!gmid || !enabled) return undefined;
    let dead = false;
    let timer;
    const tick = async () => {
      try {
        const res = await fetch(`${SB_BASE}/${encodeURIComponent(gmid)}/bootstrap`, {
          cache: 'no-store', credentials: 'omit', headers: { accept: 'application/json' },
        });
        const isJson = /application\/json/i.test(res.headers.get('content-type') || '');
        if (!dead && isJson) {
          if (res.status === 404) setBoot(null);
          else if (res.ok) { const j = await res.json(); if (!dead) setBoot(j?.score || null); }
        }
      } catch { /* network — purana boot rehne do */ }
      if (!dead) timer = setTimeout(tick, document.hidden ? POLL_MS * 3 : POLL_MS);
    };
    tick();
    return () => { dead = true; clearTimeout(timer); };
  }, [gmid, enabled]);
  return boot;
}

const norm = (s) => String(s || '').toLowerCase().replace(/\bwomen\b|\bw\b/g, ' w ').replace(/[^a-z0-9 ]/g, ' ').replace(/\s+/g, ' ').trim();
const title = (s) => String(s || '').trim().toLowerCase().replace(/(^|[\s(.'-])([a-z])/g, (_m, p, c) => p + c.toUpperCase());
const acronym = (s) => norm(s).split(' ').filter(Boolean).map((w) => w[0]).join('');

/** sky team naam vs allpanel team (name/code) — match score (0 = no match) */
function nameScore(skyName, ap) {
  const a = norm(skyName), b = norm(ap?.name), code = String(ap?.code || '').toLowerCase();
  if (!a || (!b && !code)) return 0;
  if (a === b) return 100;
  if (b && (a.includes(b) || b.includes(a))) return 80;
  const ta = new Set(a.split(' ')), tb = b.split(' ').filter((t) => t.length > 2);
  const common = tb.filter((t) => ta.has(t)).length;
  if (common) return 50 + common;
  if (code && (acronym(skyName) === code || a.replace(/ /g, '').startsWith(code))) return 40;
  return 0;
}

/**
 * Purane scoreData (sky backend + ball feeds + bet99) me team naam + innings score allpanel se.
 * d = enrichedScoreData (ya {data:{...}}), boot = useAllpanelBoot() ka result.
 */
export function applyAllpanelScore(input, boot) {
  if (!boot) return input;
  const sd = boot.sportDetails || {};
  const apInnings = Array.isArray(sd.innings) ? sd.innings : [];
  const detail = boot.event?.detail || {};
  const match = boot.event?.match || {};
  const home = { name: detail.homeTeam?.name || match.home?.name, code: detail.homeTeam?.code || match.home?.code };
  const away = { name: detail.awayTeam?.name || match.away?.name, code: detail.awayTeam?.code || match.away?.code };
  if (!home.code || !away.code) return input;

  const wrapped = !!(input?.data && typeof input.data === 'object' && !Array.isArray(input.data));
  const d = (wrapped ? input.data : input) || {};
  const teams = d.teams || {};
  let k1 = teams.team1?.key || d.score?.team1Key || '';
  let k2 = teams.team2?.key || d.score?.team2Key || '';
  const n1 = teams.team1?.name || '', n2 = teams.team2?.name || '';

  // allpanel code → sky key
  let codeToKey = null;
  if (k1 && k2 && n1 && n2) {
    const straight = nameScore(n1, home) + nameScore(n2, away);
    const swapped = nameScore(n1, away) + nameScore(n2, home);
    if (straight > swapped && straight >= 40) codeToKey = { [home.code]: k1, [away.code]: k2 };
    else if (swapped > straight && swapped >= 40) codeToKey = { [away.code]: k1, [home.code]: k2 };
    if (!codeToKey) return input; // naam match nahi — purana hi rehne do
  } else {
    // backend ke paas teams hi nahi — allpanel ki teams use karo
    k1 = 'AP1'; k2 = 'AP2';
    codeToKey = { [home.code]: k1, [away.code]: k2 };
  }
  const keyToAp = { [codeToKey[home.code]]: home, [codeToKey[away.code]]: away };
  const upperMap = {};
  Object.keys(codeToKey).forEach((c) => { upperMap[String(c).toUpperCase()] = codeToKey[c]; });
  const keyOf = (c) => upperMap[String(c || '').toUpperCase()] || '';

  // Chalu innings ke liye boot.score sabse taaza
  const inn = apInnings.map((x, i) => (
    i === apInnings.length - 1 && boot.score?.overs != null && x.number === sd.inningsNumber
      ? { ...x, runs: boot.score.runs ?? x.runs, wickets: boot.score.wickets ?? x.wickets, overs: boot.score.overs }
      : x
  ));
  const battingKey = keyOf(sd.battingTeam?.code || inn[inn.length - 1]?.battingCode);

  const out = {
    ...d,
    bet99Score: null, // allpanel hai to bet99 score/batting override na kare
    teams: {
      team1: { ...(teams.team1 || {}), key: k1, name: title(keyToAp[k1]?.name) || n1, ...(battingKey ? { batting: battingKey === k1 } : {}) },
      team2: { ...(teams.team2 || {}), key: k2, name: title(keyToAp[k2]?.name) || n2, ...(battingKey ? { batting: battingKey === k2 } : {}) },
    },
  };
  if (inn.length) {
    const slot = (n) => inn.find((x) => Number(x.number) === n);
    const plain = (x) => (x ? { runs: Number(x.runs) || 0, wickets: Number(x.wickets) || 0, overs: x.overs } : null);
    const innings = { ...(d.innings || {}) };
    const score = { ...(d.score || { format: match.format || '', status: '', raw: {} }), team1Key: d.score?.team1Key || k1, team2Key: d.score?.team2Key || k2 };
    [1, 2, 3, 4].forEach((n) => {
      const x = slot(n);
      score[`innings${n}`] = plain(x);
      innings[`innings${n}`] = x ? { ...(d.innings?.[`innings${n}`] || {}), ...plain(x), team: keyOf(x.battingCode) } : null;
    });
    out.score = score;
    out.innings = innings;
  }
  // ── Batters / bowler / this over / last ball (screenshot wala hissa) — allpanel se ──
  const bats = Array.isArray(sd.currentBatters) ? sd.currentBatters : [];
  const bowler = sd.bowler || null;
  const innIdx = Math.max(0, (inn.length || 1) - 1);
  const v1Extra = [];
  if (bats.length) {
    const b1 = bats.find((b) => b.onStrike) || bats[0];
    const b2 = bats.find((b) => b !== b1) || null;
    v1Extra.push({
      type: 'o', _ap: true, inning: innIdx,
      p1: title(b1?.name), s1: b1 ? `${b1.runs}(${b1.balls})` : '',
      p2: b2 ? title(b2.name) : '', s2: b2 ? `${b2.runs}(${b2.balls})` : '',
      ...(bowler?.name ? { bowler: title(bowler.name), bd: `${bowler.wickets}-${bowler.runs}(${bowler.overs})` } : {}),
    });
    if (bowler?.name) {
      // bowler naam component "X to Y" commentary se leta hai
      v1Extra.push({ type: 'b', _ap: true, inning: innIdx, id: `ap-${sd.deliveryId || ''}`, c1: `${title(bowler.name)} to ${title(b1?.name)}`, b: String(sd.display || '') });
    }
  }
  const groupBalls = sd.currentGroup?.balls?.length ? sd.currentGroup.balls
    : (Array.isArray(sd.recentOvers) && sd.recentOvers.length ? sd.recentOvers[sd.recentOvers.length - 1]?.balls || [] : []);
  const overNo = parseInt(String(sd.currentGroup?.label || '').replace(/\D/g, ''), 10) || (parseInt(sd.overNumber, 10) || 0) + 1;
  const toRb = (b) => {
    const cat = b.displayCategory, disp = String(b.display || '').toUpperCase(), n = parseInt(disp, 10) || 0;
    if (cat === 'WICKET') return { t: 1, u: 'W' };
    if (cat === 'SIX') return { t: 3, u: '6' };
    if (cat === 'FOUR') return { t: 2, u: '4' };
    if (disp.includes('WD')) return { t: 4, u: 'wd' };
    if (disp.includes('NB')) return { t: 5, u: 'nb' };
    if (disp.includes('LB')) return { t: 7, u: String(n || 1) };
    if (/\dB$|^B\d/.test(disp)) return { t: 6, u: String(n || 1) };
    return { t: 0, u: String(n) };
  };
  const liveData = { ...(d.liveData || {}) };
  if (bats.length) { delete liveData.s; delete liveData.q; } // batter runs ab s1/s2 (allpanel) se
  if (groupBalls.length) liveData.rb = [{ o: overNo, i: innIdx, b: groupBalls.map(toRb) }];
  const st = sd.status;
  if (st?.label && st.kind && st.kind !== 'BALL_PHASE') liveData.B = title(st.label); // break / drinks wagaira
  else if (sd.displayCategory) {
    const disp = String(sd.display || '').toUpperCase();
    liveData.B = sd.displayCategory === 'WICKET' ? 'W' : sd.displayCategory === 'SIX' ? '6' : sd.displayCategory === 'FOUR' ? '4'
      : disp.includes('WD') ? 'Wd' : disp.includes('NB') ? 'Nb' : String(parseInt(disp, 10) || 0);
  }
  out.liveData = liveData;
  if (v1Extra.length) out.v1 = [...v1Extra, ...(Array.isArray(d.v1) ? d.v1 : [])];

  return wrapped ? { ...input, data: out } : out;
}
